/**
 * Created by Timur on 27.07.2026
 */

const BalloonRiseMerge2Adapter = {
    SubscribeToEvents: function () {
        cleverapps.missionManager.on("add", (mission) => {
            if (mission.getType() !== Mission.TYPE_BALLOON_RISE) {
                return;
            }

            BalloonRiseMerge2Adapter.restoreTimer(mission);

            if (!Merge2.current) {
                return;
            }

            cleverapps.eventBus.trigger("updateExtraBar");
            cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
        });

        cleverapps.eventBus.on("customersRestored", () => {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_BALLOON_RISE);
            if (!mission) {
                BalloonRiseMerge2Adapter.destroyTimer();
                cleverapps.dataLoader.remove(DataLoader.TYPES.BALLOON_RISE_MERGE2);
                return;
            }

            if (!BalloonRiseMerge2Adapter.timer) {
                BalloonRiseMerge2Adapter.restoreTimer(mission);
            }
        });

        cleverapps.missionManager.on("remove", (mission) => {
            if (mission.getType() === Mission.TYPE_BALLOON_RISE) {
                cleverapps.extraBar.removeIcon(BalloonRiseExtraBarIcon);
                cleverapps.eventBus.trigger("ordersDataSourceUpdateAll");
                BalloonRiseMerge2Adapter.destroyTimer();
            }
        });

        cleverapps.missionManager.on("balloonRiseLoseProcessed", () => {
            BalloonRiseMerge2Adapter.destroyTimer();
        });

        cleverapps.missionManager.on("clickReceiveButton", (type) => {
            if (type !== Mission.TYPE_BALLOON_RISE) {
                return;
            }

            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_BALLOON_RISE);
            if (!mission || !mission.isRunning() || !mission.logic.isStageCompleted()) {
                return;
            }

            mission.logic.updateIcon();

            let rewards = {};
            while (mission.logic.isStageCompleted()) {
                const stage = mission.logic.getCurrentStage();
                rewards = RewardsList.sumRewards(rewards, stage.prize);
                mission.logic.updateStage();
            }

            BalloonRiseMerge2Adapter.destroyTimer();

            cleverapps.focusManager.display({
                focus: "balloonRiseReward",
                stack: true,
                actions: [
                    function (f) {
                        new RewardWindow(new RewardsList(rewards, {
                            event: cleverapps.EVENTS.BALLOON_RISE.EARN,
                            toBubbleStack: true
                        }));
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    },
                    function (f) {
                        const ViewClass = mission.isRunning() && mission.getViewClass();
                        if (!ViewClass) {
                            f();
                            return;
                        }

                        new ViewClass(mission);
                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                ]
            });
        });

        cleverapps.missionManager.on("balloonRisePlay", () => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_BALLOON_RISE);
            if (!mission || !mission.isRunning() || !Merge2.current) {
                return;
            }

            const customersList = Merge2.current.customers.listCustomersWithRecipe().filter((customer) => !customer.recipe.sideQuest);
            if (!customersList.length) {
                return;
            }

            Merge2.current.changeMode(Merge2.MODE_GAME, () => {});

            cleverapps.focusManager.whenFreeFocus(() => {
                cleverapps.focusManager.display({
                    focus: "BalloonRiseShowPlayHint",
                    keepControls: true,
                    actions: [
                        (f) => {
                            const customerView = customersList[0].onGetView();
                            FingerView.hintTap(customerView, {
                                runOnce: true,
                                callback: f
                            });
                            cleverapps.focusManager.setEventNodes([customerView]);

                            cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable.scrollToRow(customersList[0].recipe.index);
                        }
                    ]
                });
            });
        });

        cleverapps.eventBus.on("spendEnergy", (amount) => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_BALLOON_RISE);
            if (!mission || !mission.isRunning() || !mission.logic.isUnlocked()) {
                return;
            }

            mission.logic.incLevel(amount);

            if (mission.logic.isStageCompleted()) {
                BalloonRiseMerge2Adapter.destroyTimer();
            } else if (!BalloonRiseMerge2Adapter.timer) {
                BalloonRiseMerge2Adapter.createTimer(mission);
            }
        });

        cleverapps.eventBus.on("updateExtraBar", () => {
            const mission = cleverapps.missionManager.findByType(Mission.TYPE_BALLOON_RISE);
            if (!mission || !mission.isRunning()) {
                return;
            }

            if (cleverapps.resolution.isVertical()) {
                cleverapps.extraBar.removeIcon(BalloonRiseExtraBarIcon, true);
            } else {
                cleverapps.extraBar.addIcon(BalloonRiseExtraBarIcon);
            }
        });
    },

    restoreTimer: function (mission) {
        const data = cleverapps.dataLoader.load(DataLoader.TYPES.BALLOON_RISE_MERGE2);
        if (!data || !data.lastProgressTime) {
            return;
        }

        if (!mission.logic.isUnlocked()) {
            cleverapps.dataLoader.remove(DataLoader.TYPES.BALLOON_RISE_MERGE2);
            return;
        }

        BalloonRiseMerge2Adapter.createTimer(mission, data.lastProgressTime);
    },

    createTimer: function (mission, lastProgressTime) {
        BalloonRiseMerge2Adapter.destroyTimer();

        const timer = new BalloonRiseLoseTimer(mission, lastProgressTime);
        timer.onExpiredCallback = () => BalloonRiseMerge2Adapter.onTimerExpired(mission);
        BalloonRiseMerge2Adapter.timer = timer;

        if (timer.getTimeLeft() <= 0) {
            BalloonRiseMerge2Adapter.onTimerExpired(mission);
        }
    },

    destroyTimer: function () {
        if (BalloonRiseMerge2Adapter.timer) {
            BalloonRiseMerge2Adapter.timer.remove();
            BalloonRiseMerge2Adapter.timer = undefined;
        }
    },

    onTimerExpired: function (mission) {
        if (!mission.isRunning()) {
            return;
        }

        mission.logic.needShowLoseWindow = true;
        mission.logic.showLoseWindow();
    }
};

cleverapps.whenAllInitialized(() => BalloonRiseMerge2Adapter.SubscribeToEvents());
